import { Inject, Injectable } from '@angular/core';
import { HttpResponse } from '@angular/common/http';
import { isNil, omit } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

import { $frontendTypes } from './Invoices.frontend.types'

@Injectable({ providedIn: 'root' })
export class Invoices_invoicing_transactionService {

  constructor(
    private utils: UtilsService,
    private settings: SettingsValuesService,
    ) { 
  }

  async run(inParams: { payload?: $frontendTypes.Invoices.Transaction[], action?: string, skip?: number, take?: number }): Promise<{ payload?: $frontendTypes.Invoices.Transaction[], success?: boolean, error?: any[] }> 
  {
    let url = `${environment.backendUrl}api/Invoices/functions/invoicing_transaction`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.utils.http.post(url, body, options);
    
  }

}

